import { login, logout } from '@/api/AuthApi';
import contractorAuthApi from '@/api/ContractorAuthApi';

export default {
  name: 'AuthButtons',
  
  computed: {
    /**
     * ユーザー名を取得
     * Auth0のユーザー情報から名前を取得
     */
    userName() {
      if (this.$auth.user) {
        return this.$auth.user.name || this.$auth.user.nickname || '匿名ユーザー';
      }
      return '匿名ユーザー';
    },
    
    /**
     * ユーザーメールアドレスを取得
     * Auth0のユーザー情報からメールアドレスを取得
     */
    userEmail() {
      if (this.$auth.user) {
        return this.$auth.user.email || '';
      }
      return '';
    },

    /**
     * 契約社員として認証済みかどうかを確認
     */
    isContractorAuthenticated() {
      return contractorAuthApi.isAuthenticated() && contractorAuthApi.isTokenValid();
    },

    /**
     * いずれかの方法で認証済みかどうかを確認
     * Auth0認証または契約社員認証のいずれかで認証済みの場合にtrue
     */
    isAnyAuthenticated() {
      return this.$auth.isAuthenticated || this.isContractorAuthenticated;
    }
  },
  
  methods: {
    /**
     * ログインボタンのクリックハンドラ
     */
    handleLogin() {
      login();
    },
    
    /**
     * ログアウトボタンのクリックハンドラ
     * Auth0認証の場合はAuth0のログアウト、契約社員認証の場合は契約社員用のログアウトを実行
     * Auth0認証を優先してチェックする（両方のトークンが存在する場合はAuth0を優先）
     */
    handleLogout() {
      if (this.$auth.isAuthenticated) {
        logout();
      } else if (this.isContractorAuthenticated) {
        contractorAuthApi.signOut();
        window.location.href = '/contractor/signin';
      } else {
        logout();
      }
    }
  }
};
